<template>


	<div id="content" class="content join">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">회원가입</h2>
			</div>
			<form id="frm" @submit.prevent="doJoin">
				<div class="join-form gui-form">
					<!-- 필수 입력항목 표시는 necessary 클래스 -->
					<div class="row-box necessary">
						<label class="label" for="id">아이디</label>
						<div class="inp-set">
							<input id="id" name="id" type="email" placeholder="이메일 형식" v-model="coAccountVO.coEmailId" required="required" :disabled="coAccountVO.snsService === 'apple'" :style="coAccountVO.snsService === 'apple' ? 'background-color: #f6f6f6' : ''">
						</div>
						<p class="information">작성된 이메일로 최종 인증메일이 발송됩니다.</p>
					</div>
					<div class="row-box necessary" v-if="coAccountVO.caidx <= 0">
						<label class="label" for="password">비밀번호</label>
						<div class="inp-set">
							<input id="password" name="password" type="password" placeholder="8자 이상 영문, 숫자, 특수문자 포함" v-model="coAccountVO.passwd" required="required">
						</div>
						<p class="information-emph" v-show="!$options.filters.isEmpty(coAccountVO.passwd) && coAccountVO.passwd.length<8">비밀번호가 8자리 이상이 아닙니다. 다시 입력해 주세요.</p>
					</div>
					<div class="row-box necessary" v-if="coAccountVO.caidx <= 0">
						<label class="label" for="password-check">비밀번호 확인</label>
						<div class="inp-set">
							<input id="password-check" name="password-check" type="password" placeholder="비밀번호 확인" v-model="coAccountVO.passchk" required="required">
						</div>
						<p class="information-emph" v-show="!$options.filters.isEmpty(coAccountVO.passchk) && coAccountVO.passwd !== coAccountVO.passchk">비밀번호가 일치하지 않습니다. 다시 입력해 주세요.</p>
					</div>
					<div class="row-box necessary">
						<label class="label" for="userName">이름</label>
						<div class="inp-set">
							<input id="userName" name="userName" type="text" placeholder="이름" v-model="coAccountVO.userName" maxlength="20" required="required" :disabled="coAccountVO.snsService === 'apple'" :style="coAccountVO.snsService === 'apple' ? 'background-color: #f6f6f6' : ''">
						</div>
					</div>
					<div class="row-box necessary">
						<label class="label" for="nickName">닉네임</label>
						<div class="inp-set">
							<input id="nickName" name="nickName" type="text" placeholder="닉네임" v-model="coAccountVO.nickName" maxlength="20" required="required">
						</div>
					</div>
					<div class="row-box necessary">
						<label class="label" for="phoneNo2">휴대전화</label>
						<div class="inp-set">
							<input id="phoneNo2" name="phoneNo2" type="tel" placeholder="‘-’생략하고 입력" v-model="coAccountVO.phone" @keyup="numberUtils.setOnlyNum('phoneNo2')" required="required">
						</div>
						<p class="information-emph" v-show="!$options.filters.isEmpty(coAccountVO.phone) && (coAccountVO.phone.length !== 11)">올바른 휴대폰 번호가 아닙니다.</p>
					</div>
					<div class="row-box necessary">
						<!--						<label class="label" for="companyName">회사명</label>-->
						<!--						<div class="inp-set">-->
						<!--							<input id="companyName" name="companyName" type="text" placeholder="회사명" v-model="coAccountVO.companyName" maxlength="50" required="required">-->
						<!--						</div>-->
						<label class="label">회사명</label>
						<SearchableSelectBox
							ref="searchableSelectBox1"
							:placeholder="'회사명'"
							:themeColor="'#ffffff'"
							:fontColor="'#3f3f3f'"
							:model="coCodeModel"
							:valueIfNotFound="null"
							:searchTextLengthConditions4displayingLists="2"
							@getKey="getCocode"
							:id="'search-1'"
						></SearchableSelectBox>
					</div>
					<div :class="'row-box' + (isTeamCodeNull ? '' : ' necessary')">
						<!--						<label class="label" for="companyName">회사명</label>-->
						<!--						<div class="inp-set">-->
						<!--							<input id="companyName" name="companyName" type="text" placeholder="회사명" v-model="coAccountVO.companyName" maxlength="50" required="required">-->
						<!--						</div>-->
						<label class="label">소속</label>
						<SearchableSelectBox
							ref="searchableSelectBox2"
							:placeholder="'부서/직위/직책'"
							:themeColor="'#ffffff'"
							:fontColor="'#3f3f3f'"
							:model="teamCodeModel"
							:valueIfNotFound="null"
							:searchTextLengthConditions4displayingLists="0"
							@getKey="getTeamCode"
							:id="'search-2'"
							:disabled="isTeamCodeNull"
							:spacing="true"
							:withTree="true"
						></SearchableSelectBox>
					</div>

				</div>
				<div class="join-terms">
					<div class="terms-all">
						<input class="inp-check" type="checkbox" name="agree-all" id="agree-all" v-model="isAllCheck">
						<label class="lab-check" for="agree-all">전체동의</label>
					</div>
					<ul>
						<li>
							<input class="inp-check" type="checkbox" name="agree1" id="agree1" :true-value="true" :false-value="false" v-model="coAccountVO.isUseTerms">
							<label class="lab-check" for="agree1">(필수) 이용약관 동의</label>
							<button type="button" @click="openStaticPage('/app/statics/termsofservice')">내용보기</button>
						</li>
						<li>
							<input class="inp-check" type="checkbox" name="agree2" id="agree2" :true-value="true" :false-value="false" v-model="coAccountVO.isPrivacyPolicy">
							<label class="lab-check" for="agree2">(필수) 개인정보 수집 및 이용 동의</label>
							<button type="button" @click="openStaticPage('/app/statics/privacypolicy')">내용보기</button>
						</li>
						<li>
							<input class="inp-check" type="checkbox" name="agree3" id="agree3" :true-value="true" :false-value="false" v-model="coAccountVO.isMarketing">
							<label class="lab-check" for="agree3">(선택) 교육 정보 및 이벤트, 혜택 수신 동의 </label>
						</li>
					</ul>
				</div>
				<!-- trems modal -->
				<div class="modal fade" id="terms1">
					<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
						<div class="modal-content">
							<div class="modal-header">
								<h3>이용약관 동의</h3>
							</div>
							<div class="modal-body">
								<b>제 1장 총칙</b><br><br>
								<b>제 1조 (목적)</b><br>
								본 약관은 주식회사 상상플렉스(이하 "회사")이 제공하는 상상플렉스 서비스의 이용과 관련하여 "회사"와 "회원" 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
								<br><br>
								<b>제 2조 (정의)</b><br>
								본 약관에서 사용되는 용어의 정의는 다음과 같습니다.<br>
								① “상상플렉스 서비스"(이하 "서비스")라 함은 "크리에이터"로 정의된 이용자들 또는 “회사”에서 PC, 모바일 등의 각종 디지털기기 또는 소프트웨어를 통하여 오디오 콘텐츠를 방송하거나, 또는 다양한 게시물을 게시하고, 그 외 이용자들이 콘텐츠나 게시물을 보면서 댓글 내지 채팅 창 대화 등을 통하여 참여할 수 있는 오디오 콘텐츠 플랫폼 서비스를 말합니다.<br>
								② "회원"이라 함은 "서비스"에 접속하여 본 약관에 따라 "회사"와 이용계약을 체결하고 회사가 제공하는 "서비스"를 이용하는 자를 말합니다.<br>
								③ “비회원이라 함은 회원에 가입하지 않고 상상플렉스서비스를 이용하는 자를 의미합니다.<br>
								④ “이용자”라 함은 “서비스”에 접속하여 이 약관에 따라 “회사”가 제공하는 “서비스”를 이용하는 자를 의미합니다.<br>
								⑤ "닉네임"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스" 내 다른 "회원"과 자신의 구별을 위하여 "회원"이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 말합니다.<br>
								⑥ "크리에이터"라 함은 "서비스"에 자신이 제작한 콘텐츠를 게시하거나 방송을 하는 "회원"을 말합니다.<br>
								⑦ “후원”(이하 “후원” 또는 “후원 서비스”)이라 함은 “회원”이 청취 또는 조회하는 콘텐츠를 게시하거나 방송하는 "크리에이터”를 지지하기 위하여 “크리에이터 ”에게 “회원”이 보유중인 “상상플렉스캐시”를 지급하거나, 유료 결제를 통해 일정 금액을 지급하는 것을 말합니다.<br>
								⑧ “유료 콘텐츠”라 함은 “서비스”내의 “크리에이터” 또는 “회사”가 등록한 콘텐츠 중 “회원”이 유료 결제 또는 “캐시”를 지불하여 구매한 후 이용할 수 있는 콘텐츠를 말합니다.<br>
								⑨ "상상플렉스캐시"(이하 “캐시”)라 함은 “회원”이 "서비스”내에서 유료 콘텐츠를 이용하거나, “크리에이터"에게 “후원”을 하기 위해 구매하는 인터넷상 결제 수단을 말하며, “캐시” 1개는 현금 1원과 동일한 가치를 지닙니다.<br>
								⑩ “충전”이라 함은 “회원”이 “후원 서비스”, 또는 “유료 콘텐츠”를 이용하기 위해 “회사”가 정한 결제 수단 중 하나를 선택하여 현금을 “캐시”로 전환하는 행위를 말합니다.<br>
								...
							</div>
							<div class="modal-footer">
								<button type="button" data-dismiss="modal">확인</button>
							</div>
						</div>
					</div>
				</div>
				<div class="modal fade" id="terms2">
					<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
						<div class="modal-content">
							<div class="modal-header">
								<h3>개인정보 수집 및 이용 동의</h3>
							</div>
							<div class="modal-body">
								<b>제 1장 총칙</b><br><br>
								<b>제 1조 (목적)</b><br>
								본 약관은 주식회사 상상플렉스(이하 "회사")이 제공하는 상상플렉스 서비스의 이용과 관련하여 "회사"와 "회원" 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
								<br><br>
								<b>제 2조 (정의)</b><br>
								본 약관에서 사용되는 용어의 정의는 다음과 같습니다.<br>
								① “상상플렉스 서비스"(이하 "서비스")라 함은 "크리에이터"로 정의된 이용자들 또는 “회사”에서 PC, 모바일 등의 각종 디지털기기 또는 소프트웨어를 통하여 오디오 콘텐츠를 방송하거나, 또는 다양한 게시물을 게시하고, 그 외 이용자들이 콘텐츠나 게시물을 보면서 댓글 내지 채팅 창 대화 등을 통하여 참여할 수 있는 오디오 콘텐츠 플랫폼 서비스를 말합니다.<br>
								② "회원"이라 함은 "서비스"에 접속하여 본 약관에 따라 "회사"와 이용계약을 체결하고 회사가 제공하는 "서비스"를 이용하는 자를 말합니다.<br>
								③ “비회원이라 함은 회원에 가입하지 않고 상상플렉스서비스를 이용하는 자를 의미합니다.<br>
								④ “이용자”라 함은 “서비스”에 접속하여 이 약관에 따라 “회사”가 제공하는 “서비스”를 이용하는 자를 의미합니다.<br>
								⑤ "닉네임"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스" 내 다른 "회원"과 자신의 구별을 위하여 "회원"이 정하고 “회사”가 승인하는 문자와 숫자의 조합을 말합니다.<br>
								⑥ "크리에이터"라 함은 "서비스"에 자신이 제작한 콘텐츠를 게시하거나 방송을 하는 "회원"을 말합니다.<br>
								⑦ “후원”(이하 “후원” 또는 “후원 서비스”)이라 함은 “회원”이 청취 또는 조회하는 콘텐츠를 게시하거나 방송하는 "크리에이터”를 지지하기 위하여 “크리에이터 ”에게 “회원”이 보유중인 “상상플렉스캐시”를 지급하거나, 유료 결제를 통해 일정 금액을 지급하는 것을 말합니다.<br>
								⑧ “유료 콘텐츠”라 함은 “서비스”내의 “크리에이터” 또는 “회사”가 등록한 콘텐츠 중 “회원”이 유료 결제 또는 “캐시”를 지불하여 구매한 후 이용할 수 있는 콘텐츠를 말합니다.<br>
								⑨ "상상플렉스캐시"(이하 “캐시”)라 함은 “회원”이 "서비스”내에서 유료 콘텐츠를 이용하거나, “크리에이터"에게 “후원”을 하기 위해 구매하는 인터넷상 결제 수단을 말하며, “캐시” 1개는 현금 1원과 동일한 가치를 지닙니다.<br>
								⑩ “충전”이라 함은 “회원”이 “후원 서비스”, 또는 “유료 콘텐츠”를 이용하기 위해 “회사”가 정한 결제 수단 중 하나를 선택하여 현금을 “캐시”로 전환하는 행위를 말합니다.<br>
								...
							</div>
							<div class="modal-footer">
								<button type="button" data-dismiss="modal">확인</button>
							</div>
						</div>
					</div>
				</div>
				<!-- //learning modal -->
				<div class="btn-area">
					<button type="submit" class="btn-submit">회원가입</button>
				</div>

			</form>
		</div>
	</div>


</template>

<script>

/* eslint-disable no-mixed-spaces-and-tabs */
/* global $ */
import SearchableSelectBox from "@/components/selectors/searchableSelectBox";
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "joinForm",
	components: {SearchableSelectBox},
	props: {

	},
	data() {

		return {
			coAccountVO: new this.CoAccountVO(),

			isAllCheck: false,
			coCodeModel: {},
			teamCodeModel: [],
			coCode: 'www',
			isTeamCodeNull: true,
			// isUseTerms: false,
			// isPrivacyPolicy: false,
			// isMarketing: false,
		}
	},
	beforeCreate() {
	},
	created() {
		this.getAccount();
		this.getAllCoInfo()
		this.getClass()

		const { userName, coEmailId, companyName } = this.$route.query;
    	if (userName) this.coAccountVO.userName = userName;
    	if (coEmailId) this.coAccountVO.coEmailId = coEmailId;
		if (companyName) this.coAccountVO.companyName = companyName;
	},
	mounted() {

	},
	methods: {

		/**
		 * caidx 일 경우 데이터 조회 후 최소 데이터만 연결
		 * SNS 가입 직후일 경우
		 */
		getAccount () {

			const self = this
			const caidx = this.$route.query.caidx
			if ( !self.stringUtils.isEmpty(caidx) ) {

				this.$eventBus.$emit("startProgress")
				this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/", {
					caidx: caidx
				}, (res) => {
					self.$eventBus.$emit("doneProgress")
					const result = res.data
					console.log(res);
					self.coAccountVO = new self.CoAccountVO();
					self.coAccountVO.coEmailId = result.coAccountVO.coEmailId
					self.coAccountVO.userName = result.coAccountVO.userName
					self.coAccountVO.isSnsLogin = result.coAccountVO.isSnsLogin
					self.coAccountVO.snsService = result.coAccountVO.snsService
					self.coAccountVO.snsId = result.coAccountVO.snsId
					self.coAccountVO.caidx = result.coAccountVO.caidx
					self.coAccountVO.coCode = result.coAccountVO.coCode

					console.log(self.coAccountVO)
				})

			}

		},


		doJoin(e) {

			/**
			 * SNS 로그인 처리일 경우
			 * doJoin4SNS 처리 우회
			 */
			if ( this.coAccountVO.caidx > 0 && !this.stringUtils.isEmpty(this.coAccountVO.snsId) && !this.stringUtils.isEmpty(this.coAccountVO.snsService) ) {
				this.doJoin4SNS(e);
				return
			}

			e.preventDefault()

			//const regs = /^[A-Za-z0-9+]{8,20}/
			const regs = this.PASSWORD_REGS;
			if ( !this.stringUtils.isEmpty( this.coAccountVO.passwd ) && !regs.test( this.coAccountVO.passwd ) ) {
				this.swalUtils.gritter("새 비밀번호가 짧습니다.", "새로운 비밀번호를 영문과 숫자, 특수문자가 포함된 8 ~ 20자리 사이로 입력해주세요.", "warning", 2000)
				return;
			}

			if ( this.coAccountVO.passwd !== this.coAccountVO.passchk ) {
				this.$swal("비밀번호 확인", "비밀번호 확인란이 일치하지 않습니다.", "error")
				return
			}

			if (this.coAccountVO.phone.length !== 11) {
				this.$swal("전화번호 확인", "올바른 휴대폰 번호가 아닙니다.", "error")
				return
			}

			if ( !this.coAccountVO.isUseTerms ) {
				this.$swal("이용약관 동의 필수선택", "이용약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.coAccountVO.isPrivacyPolicy ) {
				this.$swal("개인정보 수집 및 이용 동의 필수선택", "개인정보 수집 및 이용 동의 약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.isTeamCodeNull && (this.coAccountVO.teamCode == null || this.coAccountVO.teamCode === "") ) {
				this.$swal("소속 선택", "선택된 소속이 없습니다.", "error")
				return
			}

			this.coAccountVO.companyName = $('#search-1').val()
			if (!this.coAccountVO.companyName) {
				this.$swal("회사명 입력", "입력된 회사명이 없습니다.", "error")
				return
			}

			this.$eventBus.$emit("startProgress")

			if (!this.coAccountVO.rateCode) {
				delete this.coAccountVO.rateCode
			}

			this.axiosCaller.post( this, this.APIs.CO_ACCOUNT + "/", this.coAccountVO, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data
				if ( result.status === "ok" ) {
					this.coAccountVO = result.coAccountVO
					this.$router.push({
						name: "joinDone",
						query: {
							caidx: this.coAccountVO.caidx
						}
					})
				} else if ( result.status === "fail" ) {
					this.swalUtils.gritter("처리 오류", result.msg, "warning", 3000);
				} else if ( result.status === "error" ) {
					console.log( result.msg )
					this.swalUtils.gritter("처리 오류", "시스템 오류로 처리되지 않았습니다. 관리자에게 문의하세요", "warning", 3000);
				}
			})

		},


		doJoin4SNS(e) {

			e.preventDefault()

			if ( !this.coAccountVO.isUseTerms ) {
				this.$swal("이용약관 동의 필수선택", "이용약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.coAccountVO.isPrivacyPolicy ) {
				this.$swal("개인정보 수집 및 이용 동의 필수선택", "개인정보 수집 및 이용 동의 약관에 동의하셔야 사이트를 이용할 수 있습니다.", "error")
				return
			}
			if ( !this.isTeamCodeNull && (this.coAccountVO.teamCode == null || this.coAccountVO.teamCode === "") ) {
				this.$swal("소속 선택", "선택된 소속이 없습니다.", "error")
				return
			}

			this.coAccountVO.companyName = $('#search-1').val()
			if (!this.coAccountVO.companyName) {
				this.$swal("회사명 입력", "입력된 회사명이 없습니다.", "error")
				return
			}

			this.$eventBus.$emit("startProgress")

			if (!this.coAccountVO.rateCode) {
				delete this.coAccountVO.rateCode
			}

			this.axiosCaller.post( this, this.APIs.CO_ACCOUNT + "/sns", this.coAccountVO, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data
				if ( result.status === "ok" ) {
					this.coAccountVO = result.coAccountVO
					this.$router.push({
						name: "joinDone",
						query: {
							caidx: this.coAccountVO.caidx
						}
					})
				} else if ( result.status === "fail" ) {
					this.swalUtils.gritter("처리 오류", result.msg, "warning", 3000);
				} else if ( result.status === "error" ) {
					console.log( result.msg )
					this.swalUtils.gritter("처리 오류", "시스템 오류로 처리되지 않았습니다. 관리자에게 문의하세요", "warning", 3000);
				}
			})

		},

		getAllCoInfo() {
			this.axiosCaller.get(this, this.APIs.CO_INFO + "/infoAll", {}, (res) => {
				const result = res.data

				if (result.status === "ok") {
					let tempObj = {}
					result.data.forEach(e => tempObj[e.coCode] = e.coName)
					this.coCodeModel = tempObj
				}
			})
		},

		getCocode(key) {
			if (key === null) {
				this.isTeamCodeNull = true
				key = 'www'
			} else {
				this.isTeamCodeNull = false
			}
			this.coCode = key
		},

		getTeamCode(key) {
			this.teamCode = key
			this.coAccountVO.teamCode = key
		},

		getClass() {
			this.axiosCaller.get( this, this.APIs.CO_INFO + "/getClassTree/" + this.coCode, {}, (res) => {

				const result = res.data
				if (result.status === "ok") {
					let codeList = result.codeList
					let tempArr = []
					let minimumLevel = Math.min.apply(null, codeList.map(e => e.codeLevel))

					codeList.forEach(e => {
						tempArr.push({key: e.code, value: e.codeName, space: e.codeLevel - minimumLevel})
					})

					this.teamCodeModel = tempArr

				}
			})
		}

	},
	computed: {
		allow: function() {
			return [[this.coAccountVO.isUseTerms, this.coAccountVO.isPrivacyPolicy, this.coAccountVO.isMarketing], this.isAllCheck]
		}
	},
	watch: {

		// 'isAllCheck': function (newVal, oldVal) {
		// 	this.coAccountVO.isUseTerms = newVal
		// 	this.coAccountVO.isPrivacyPolicy = newVal
		// 	this.coAccountVO.isMarketing = newVal
		// },

		'coCodeModel': function(v) {
			this.$nextTick(() => {
				this.$refs.searchableSelectBox1.updateModel(v)
			})
		},

		'coCode': function(n, o) {
			if (n !== o) {
				this.teamCodeModel = []
				this.coAccountVO.teamCode = ""
				this.$refs.searchableSelectBox2.searchText = ""
				$('#search-2').val('')

				this.getClass(n)
			}
			this.coAccountVO.coCode = n
		},

		allow: function (n, o) {
			if (n[1] === o[1]) {
				this.isAllCheck = this.allow[1] = this.allow[0].every((e, i, a) => e === a[0]) && this.allow[0][0]
				if (this.allow[1]) this.coAccountVO.isUseTerms = this.coAccountVO.isPrivacyPolicy = this.coAccountVO.isMarketing = true
			} else {
				this.coAccountVO.isUseTerms = this.coAccountVO.isPrivacyPolicy = this.coAccountVO.isMarketing = this.allow[1]
			}
		}

	},

}
</script>

<style scoped>

</style>
